/*
 * 给普通函数使用装饰器
 * @param func 需要装饰的函数
 * @param decoratorFunc 装饰器
 */
export function useDecorator(func, decoratorFunc) {
  const forkFunction = {
    value: func
  }
  decoratorFunc(func, func.name, forkFunction)
  func = forkFunction.value
  return func
}

/*
 * 给async函数使用装饰器
 * @param func 需要装饰的函数
 * @param decoratorFunc 装饰器
 */
export function useDecoratorAsync(asyncfunc, decoratorFunc, ...args) {
  const forkFunction = {
    value: asyncfunc
  }
  decoratorFunc(asyncfunc, asyncfunc.name, forkFunction, ...args)

  const newFunc = async (...args) => {
    // eslint-disable-next-line
    return await forkFunction.value.apply(this, args)
  }
  asyncfunc = newFunc
  return asyncfunc
}
